'use es6';

import { Component } from 'react';
import colr from './vendor/colr';
import Panel from './Panel';
import { getHexOrFallback, parseHex, parseHexOrFallback } from './utils/parseHex';
import { withTokenProps } from 'foundations-components/utils/withTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
const computeHue = hex => {
  var _parseHex;
  const hsv = (_parseHex = parseHex(hex)) === null || _parseHex === void 0 ? void 0 : _parseHex.toHsvObject();
  if (hsv == null || hsv.s === 0) return null;
  return hsv.h;
};
const computeColorWithHue = (hex, hue) => {
  const hsv = colr.fromHex(hex).toHsvObject();
  if (hsv.s === 0) {
    return hex; // Hue has no effect on a color with no saturation.
  }
  return colr.fromHsvObject(Object.assign({}, hsv, {
    h: hue
  })).toHex();
};
const InitialColor = '#ffffff';
class ColorPicker extends Component {
  static getDerivedStateFromProps(props, state) {
    const {
      prevHex
    } = state;
    const {
      color: hex
    } = props;
    if (prevHex !== hex) {
      const computedHue = computeHue(hex);
      if (computedHue != null) return {
        hue: computedHue,
        prevHex: hex
      };
      return {
        prevHex: hex
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      hue: parseHexOrFallback(props.color).toHsvObject().h,
      prevHex: props.color
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange({
    alpha,
    hex = this.props.color,
    hue
  }) {
    let color = hex;
    if (hue != null) {
      const currentHue = computeHue(hex);
      if (currentHue == null) {
        this.setState({
          hue
        });
      } else {
        color = computeColorWithHue(hex, hue);
      }
    }
    const changes = {};
    if (color != null) changes.color = color;
    if (alpha != null) changes.alpha = alpha;
    this.props.onChange(changes);
  }
  render() {
    const {
      alpha,
      color: hex,
      favorites,
      fieldsetSize,
      hexOnly,
      includeAlpha,
      onBlur,
      onFocus,
      cssStyles
    } = this.props;
    const {
      hue
    } = this.state;
    return /*#__PURE__*/_jsx(Panel, {
      "data-test-id": "colorpicker-advanced",
      includeAlpha: includeAlpha,
      hexOnly: hexOnly,
      favorites: favorites,
      fieldsetSize: fieldsetSize,
      alpha: alpha,
      hex: getHexOrFallback(hex),
      hue: hue,
      onChange: this.handleChange,
      onBlur: onBlur,
      onFocus: onFocus,
      mode: this.props.mode,
      cssStyles: cssStyles
    });
  }
}
ColorPicker.defaultProps = {
  color: InitialColor,
  includeAlpha: false,
  hexOnly: true,
  favorites: [],
  alpha: 100,
  onChange: () => null,
  onBlur: () => null,
  onFocus: () => null,
  style: {}
};
export default withTokenProps(ColorPicker);

/**
 * @typedef {Object} ColorPickerProps
 * @property {number} [alpha]
 * @property {string} color - required
 * @property {Object} [cssStyles]
 * @property {string[]} [favorites]
 * @property {'default'|'small'} [fieldsetSize]
 * @property {boolean} [hexOnly]
 * @property {boolean} [includeAlpha]
 * @property {'RGB'|'HSL'|'HSB'} [mode]
 * @property {function(): void} [onBlur]
 * @property {function({color?: string, alpha?: number}): void} [onChange]
 * @property {function(): void} [onFocus]
 */